import { useQuery } from '@tanstack/vue-query'
import { apiClient } from '@/apis/instances/api-client'
import { checkApiResponse } from '@/apis/instances/check-api-response'
import { ApiStatsV2ReservationMonthlyElFindParams } from '@/apis/swaggers/v2/v2-swagger'
import { QUERY_KEY } from '@/apis/swaggers/swagger-docs'
import { QueryComposableParams } from '@/types/query-options'
import { resolveMaybeGetter } from '@/util/resolve-maybe-getter'

type QueryParams = QueryComposableParams<ApiStatsV2ReservationMonthlyElFindParams, unknown>

const fetchStatsReservationMonthly = async (params: ApiStatsV2ReservationMonthlyElFindParams) => {
  const { data } = await apiClient.v2.apiStatsV2ReservationMonthlyElFind(params);
  return checkApiResponse(data);
}

export const statsReservationMonthlyKeys = {
  all: [QUERY_KEY.v2apiStatsV2ReservationMonthlyElFind] as const,
  list: (params: ApiStatsV2ReservationMonthlyElFindParams) => [...statsReservationMonthlyKeys.all, params] as const,
}

/** 명령형(await) 호출용 쿼리 정의 — `queryClient.fetchQuery(statsV2ReservationMonthlyFindQueryOptions(params))` */
export const statsV2ReservationMonthlyFindQueryOptions = (params: ApiStatsV2ReservationMonthlyElFindParams) => ({
  queryKey: statsReservationMonthlyKeys.list(params),
  queryFn: () => fetchStatsReservationMonthly(params),
})

export const useStatsV2ReservationMonthlyFindQuery = ({ params, options }: QueryParams) => {
  return useQuery(() => ({
    queryKey: statsReservationMonthlyKeys.list(resolveMaybeGetter(params)),
    queryFn: () => fetchStatsReservationMonthly(resolveMaybeGetter(params)),
    ...resolveMaybeGetter(options ?? {}),
  }))
}
